import { Provider } from '@angular/core';

export const PROVIDERS_INJECTABLE_BY_KEY: Provider[] = [];

export const InjectableByKey = ({ key }) => {
  return (target) => {
    const providerItem: Provider = {
      provide: key,
      useExisting: target,
    };

    PROVIDERS_INJECTABLE_BY_KEY.push(providerItem);

    return target;
  };
};
